import React from 'react';
import axios from 'axios';
import fileDownload from 'js-file-download';

import WorkerCase from './WorkerCase';
import ChooseRegionForMailing from './ChooseRegionForMailing';
import AgreedAMsForCase from './AgreedAMsForCase';

import { useModal } from '../Components/Modal/ModalContext';
import { useTimeModal } from '../Components/TimeModal/TimeModalContext';

import Loading from './Loading';

import styles from '../styles/DynamicModal.module.css';

export const CardOfCase = ({ closeModal, id, onCardOfCaseSuccess }) => {
    const { openModal } = useModal();
    const { openTimeModal } = useTimeModal();
    const [cases, setCases] = React.useState([]);
    const [warning, setWarning] = React.useState('');
    const [reload, setReload] = React.useState(true);
    const [confirmDelete, setConfirmDelete] = React.useState(false);
    const [highlightedPhase, setHighlightedPhase] = React.useState(null);
    const [loading, setLoading] = React.useState(true);

    const [namePhase, setNamePhase] = React.useState('');
    const [nameType, setNameType] = React.useState('');

    React.useEffect(() => {
        document.body.style.overflow = 'hidden';
    
        return () => {
            document.body.style.overflow = '';
        };
    }, []);

    const handleLogout = () => {
        localStorage.removeItem('token');
        window.location.href = '/';
    }

    const [warningDownloadFile, setWarningDownloadFile] = React.useState('');

    const downloadFile = async (id) => {
        const token = localStorage.getItem('token');
        try {
            const response = await axios.get(`/api/download-case-file/${id}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
                responseType: 'blob',
            });
    
            const contentDisposition = response.headers['content-disposition'];
            let fileName = 'downloaded_file.docx';
            
            if (contentDisposition) {
                const fileNameMatch = contentDisposition.match(/filename\s*=\s*"?([^"]+)"?/);
            
                if (fileNameMatch && fileNameMatch[1]) {
                    fileName = fileNameMatch[1];
                }
            }
    
            fileDownload(response.data, fileName);
        } catch (error) {
            console.error('Ошибка при скачивании файла: ', error);
            setWarningDownloadFile('Не удалось скачать файл: Файл мог быть уничтожен.');
        }
    }
    
    

    const goPhase = (caseId) => {
        axios.put(`/api/go-phase?caseId=${caseId}`)
        .then(() => {
            setHighlightedPhase(caseId);
            setTimeout(() => setHighlightedPhase(null), 1000);
            openTimeModal('Дело продвинуто', 'success');
            setReload(true);
        })
        .catch((error) => {
            openTimeModal(`Не удалось продвинуть дело.  ${error.response?.data.message || error.message}`, 'error');
        })
    };

    React.useEffect(() => {
        const token = localStorage.getItem('token');

        axios.get(`/api/case?caseId=${id}`, {
        headers: {
            Authorization: `Bearer ${token}`,
        }
        })
        .then(response => {
            if (response.data.length === 0) {
                setWarning('Ошибка системы.');
            } else {
                setWarning('');
                setCases(response.data);
                setNamePhase(response.data[0].phaseName);
                setNameType(response.data[0].nameType);
            }
            setLoading(false);
            setReload(false);
        })
        .catch(error => {
            if (error.response?.data.action == 'logout') {
                window.location.href = '/auth/logout';
            }
            setWarning(`Ошибка при загрузке карточки:  ${error.response?.data.message || error.message}`);
            setLoading(false);
            setReload(false);
        })
    }, [reload, id]);

    const formatDate = (dateString) => {
        const date = new Date(dateString);
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();
        return `${day}.${month}.${year}`;
    };
    const formatDateTime = (isoDate) => {
        // Убираем символы после секунды, если они есть
        const cleanDate = isoDate.replace(/\.\d+Z$/, '');
    
        const date = new Date(cleanDate);
    
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();
    
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        const seconds = String(date.getSeconds()).padStart(2, '0');
    
        return `${day}.${month}.${year} ${hours}:${minutes}:${seconds}`;
    };
    const formatComment = (comment) => {
        if (comment === 'Заметка отсутствует') {
            return <span style={{color: 'rgb(169, 169, 169)'}}>{comment}</span>
        }else {
            return <span>{comment}</span>;
        }
    };
    const formatFile = (file) => {
        if (!file) {
            return <span style={{color: 'rgb(169, 169, 169)'}}>Файл не прикреплен</span>
        }else {
            return <span>{file}</span>;
        }
    };

    const changeIsFavoriteCase = (caseId, setIsFavorite) => {
        axios.put(`/api/change-is-favorite?caseId=${caseId}&setIsFavorite=${setIsFavorite}`)
        .then(() => {
            openTimeModal('Статус дела изменен', 'success');
            setReload(true);
        })
        .catch((err) => {
            openTimeModal('Ошибка при изменении статуса дела', 'error');
        })
    };

    const deleteCase = (caseId) => {
        try {
            axios.delete(`/api/case?caseId=${caseId}`);
            window.location.reload();
        }
        catch (error) {
            openTimeModal('Ошибка при удалении дела', 'error');
        }
    };

    const [access, setAccess] = React.useState(false);
    const [isAccessLoading, setIsAccessLoading] = React.useState(true);
    React.useEffect(() => {
        const token = localStorage.getItem('token');

        if (token) {
            axios.get('/api/get-user-role', {
                headers: {
                    Authorization: `Bearer ${token}`,
                }
            }).then(response => {
                if (response.data.role == 'Администратор' ||
                    response.data.role == 'Менеджер' ||
                    response.data.role == 'Работник по назначениям' ||
                    response.data.role == 'Работник по жалобам' ||
                    response.data.role == 'Работник по общим') {
                    setAccess(true);
                }
            }).catch(err => {
                console.error('Ошибка получения данных '+err);
            })
            .finally(() => {
                setIsAccessLoading(false);
            })
        } else {
            handleLogout();
        }
    }, []);

    const handleDeleteClick = (caseId) => {
        if (confirmDelete) {
            deleteCase(caseId);
            setConfirmDelete(false);
        } else {
            setConfirmDelete(true);
        }
    };

    // Открепить арбитражного управляющего от дела
    const removeAMFromCase = () => {
        axios.put(`/api/remove-AM-from-case?caseId=${id}`)
        .then(() => {
            setReload(true);
        }).catch(() => {
            openTimeModal('Не удалось открепить арбитражного управляющего', 'error');
        });
    };

    const [shareButtonText, setShareButtonText] = React.useState('Поделиться ссылкой');

    const handleShareClick = () => {
        const link = `http://localhost:3000/case/${id}`;
        navigator.clipboard.writeText(link).then(() => {
            setShareButtonText('Ссылка на дело скопирована');
            setTimeout(() => setShareButtonText('Поделиться'), 2000);
        }).catch(err => {
            console.error('Ошибка при копировании ссылки:', err);
            setShareButtonText('Ошибка при копировании ссылки: '+err);
        });
    };

    return (
    <>
        <div className={styles.liningOver} onClick={() => {closeModal(); onCardOfCaseSuccess()}}>
            <form className={styles.lining} onClick={(e) => e.stopPropagation()}>
            <div className={styles.header}>
                <h1>{loading ? ('Загрузка карточки...') : (namePhase !== 'Назначение арбитражного управляющего' ? ('Карточка дела') : (nameType == 'Назначения' ? ('Карточка заявки') : (nameType == 'Жалобы' ? ('Карточка жалобы') : (nameType == 'Общие' ? ('Карточка письма') : ('Ошибка системы')))))}</h1>
                <svg onClick={() => {closeModal(); onCardOfCaseSuccess()}} viewBox="0 0 24 24" fill="none">
                    <path fillRule="evenodd" clipRule="evenodd" d="M5.29289 5.29289C5.68342 4.90237 6.31658 4.90237 6.70711 5.29289L12 10.5858L17.2929 5.29289C17.6834 4.90237 18.3166 4.90237 18.7071 5.29289C19.0976 5.68342 19.0976 6.31658 18.7071 6.70711L13.4142 12L18.7071 17.2929C19.0976 17.6834 19.0976 18.3166 18.7071 18.7071C18.3166 19.0976 17.6834 19.0976 17.2929 18.7071L12 13.4142L6.70711 18.7071C6.31658 19.0976 5.68342 19.0976 5.29289 18.7071C4.90237 18.3166 4.90237 17.6834 5.29289 17.2929L10.5858 12L5.29289 6.70711C4.90237 6.31658 4.90237 5.68342 5.29289 5.29289Z" fill="#000000"/>
                </svg>
            </div>
            <div className={styles.main}>
                {loading ? (
                    <Loading />
                ) : warning ? (
                    <a>{warning}</a>
                ) : (
                    cases.map((cases) => (
                        <>
                            <div style={{display: 'flex', justifyContent: 'space-between'}}>
                                <div>
                                    <h2 style={{marginTop: '0px'}}>Номер:</h2>
                                    <a>{cases.number}</a>
                                </div>
                                {isAccessLoading ? (
                                    <a style={{width: '100px', height: '20px'}}>
                                        <Loading />
                                    </a>
                                ) : 
                                !access && (cases.is_favorite ? 
                                    <button type='button' className='button' onClick={() => {changeIsFavoriteCase(cases.id, 0)}}>
                                        <svg viewBox="0 0 24 24" id="times" fill='currentColor'><path fill="#6563FF" d="M13.41,12l4.3-4.29a1,1,0,1,0-1.42-1.42L12,10.59,7.71,6.29A1,1,0,0,0,6.29,7.71L10.59,12l-4.3,4.29a1,1,0,0,0,0,1.42,1,1,0,0,0,1.42,0L12,13.41l4.29,4.3a1,1,0,0,0,1.42,0,1,1,0,0,0,0-1.42Z"></path></svg>
                                        Открепить
                                    </button> 
                                    : 
                                    <button type='button' className='button' onClick={() => {changeIsFavoriteCase(cases.id, 1)}}>
                                        <svg viewBox="0 0 24 24" id="bookmark" fill='currentColor'><path d="M16,2H8A3,3,0,0,0,5,5V21a1,1,0,0,0,.5.87,1,1,0,0,0,1,0L12,18.69l5.5,3.18A1,1,0,0,0,18,22a1,1,0,0,0,.5-.13A1,1,0,0,0,19,21V5A3,3,0,0,0,16,2Zm1,17.27-4.5-2.6a1,1,0,0,0-1,0L7,19.27V5A1,1,0,0,1,8,4h8a1,1,0,0,1,1,1Z"></path></svg>
                                        Закрепить
                                    </button>
                                )}
                            </div>
                            <h2>Категория:</h2>
                            <a>{cases.nameCategory}</a>
                            <h2>Текущий этап:</h2>
                            <div className={styles.phaseContainer}>
                            {cases.status=="В работе" ? (
                                <>
                                    <a className={styles.phaseO}>
                                        <svg style={{width: '37px'}} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" id="angle-double-right"><path fill="#6563FF" d="M8.46,8.29A1,1,0,1,0,7,9.71L9.34,12,7,14.29a1,1,0,0,0,0,1.42,1,1,0,0,0,1.42,0l3-3a1,1,0,0,0,0-1.42Zm8.5,3-3-3a1,1,0,0,0-1.42,1.42L14.84,12l-2.3,2.29a1,1,0,0,0,0,1.42,1,1,0,0,0,1.42,0l3-3A1,1,0,0,0,17,11.29Z"></path></svg>
                                        {cases.phaseName}
                                    </a>
                                    {cases.nextFirstPhaseName != '' && 
                                    <>
                                        <svg className={styles.bridge} xmlns="http://www.w3.org/2000/svg" data-name="Layer 1" viewBox="0 0 24 24" id="arrow-down"><path fill="currentColor" d="M17.71,11.29a1,1,0,0,0-1.42,0L13,14.59V7a1,1,0,0,0-2,0v7.59l-3.29-3.3a1,1,0,0,0-1.42,1.42l5,5a1,1,0,0,0,.33.21.94.94,0,0,0,.76,0,1,1,0,0,0,.33-.21l5-5A1,1,0,0,0,17.71,11.29Z"></path></svg>
                                        <a className={styles.phaseOnoncurrent}>
                                            <svg id="clock" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill="currentColor" d="M15.09814,12.63379,13,11.42285V7a1,1,0,0,0-2,0v5a.99985.99985,0,0,0,.5.86621l2.59814,1.5a1.00016,1.00016,0,1,0,1-1.73242ZM12,2A10,10,0,1,0,22,12,10.01114,10.01114,0,0,0,12,2Zm0,18a8,8,0,1,1,8-8A8.00917,8.00917,0,0,1,12,20Z"></path></svg>
                                            {cases.nextFirstPhaseName}
                                        </a>
                                    </>
                                    }
                                    {cases.nextSecondPhaseName != '' && 
                                    <>
                                        <svg className={styles.bridge} xmlns="http://www.w3.org/2000/svg" data-name="Layer 1" viewBox="0 0 24 24" id="arrow-down"><path fill="currentColor" d="M17.71,11.29a1,1,0,0,0-1.42,0L13,14.59V7a1,1,0,0,0-2,0v7.59l-3.29-3.3a1,1,0,0,0-1.42,1.42l5,5a1,1,0,0,0,.33.21.94.94,0,0,0,.76,0,1,1,0,0,0,.33-.21l5-5A1,1,0,0,0,17.71,11.29Z"></path></svg>
                                        <a className={styles.phaseOnoncurrent}>
                                            <svg id="clock" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill="currentColor" d="M15.09814,12.63379,13,11.42285V7a1,1,0,0,0-2,0v5a.99985.99985,0,0,0,.5.86621l2.59814,1.5a1.00016,1.00016,0,1,0,1-1.73242ZM12,2A10,10,0,1,0,22,12,10.01114,10.01114,0,0,0,12,2Zm0,18a8,8,0,1,1,8-8A8.00917,8.00917,0,0,1,12,20Z"></path></svg>
                                            {cases.nextSecondPhaseName}
                                        </a>
                                    </>
                                    }
                                </>
                            ) : (
                                <a className={styles.phaseOComplite}>
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" id="check-circle"><path fill="currentColor" d="M14.72,8.79l-4.29,4.3L8.78,11.44a1,1,0,1,0-1.41,1.41l2.35,2.36a1,1,0,0,0,.71.29,1,1,0,0,0,.7-.29l5-5a1,1,0,0,0,0-1.42A1,1,0,0,0,14.72,8.79ZM12,2A10,10,0,1,0,22,12,10,10,0,0,0,12,2Zm0,18a8,8,0,1,1,8-8A8,8,0,0,1,12,20Z"></path></svg>
                                    Дело завершено
                                </a>
                            )}
                            </div>
                            <h2>Истец:</h2>
                            <a>{cases.applicant}</a>
                            {access &&
                            <>
                                <h2>За кем закреплено:</h2>
                                <WorkerCase caseId={cases.id} workerId={cases.worker_id} onAppointWorkerForCaseSuccess={() => {setReload(true)}} />
                            </>
                            }
                            {access && 
                            <>
                                <h2>Арбитражный управляющий:</h2>
                                <div style={{display: 'flex', flexDirection: 'column'}}>
                                    {cases.worker_id ? 
                                    (cases.mailing_status === "Письма не отправлены" ? 
                                        (
                                            
                                            <ChooseRegionForMailing idCase={id} onMailingSuccess={() => {setReload(true)}} />
                                            
                                        ) : cases.mailing_status === "Письма отправлены" ? (

                                            <AgreedAMsForCase idCase={id} onAppointmentSuccess={() => {setReload(true)}} />

                                        ) : cases.mailing_status === "Дело присвоено" ? (
                                        <>
                                            <a>Дело присвоено:</a>
                                            {cases.userDetails == null ? 
                                                <>
                                                    <a className={styles.statusPanel}><img src='/img/icons/warning-icon.svg' alt='Предупреждение' />Произошла ошибка: учётная запись арбитражного управляющего не найдена в системе «Поток». Возможно, она была удалена по запросу.</a> 
                                                </>
                                                : 
                                                <>
                                                    <a>{cases.userDetails?.lastname} {cases.userDetails?.firstname} {cases.userDetails?.surname}</a>
                                                    <a style={{textDecoration: 'underline black', width: 'fit-content'}} href={`mailto:${cases.userDetails?.email}`}>{cases.userDetails?.email}</a>
                                                </>
                                            }
                                            <button type='button' className='button' onClick={() => {removeAMFromCase()}}>Открепить арбитражного управляющего</button>
                                        </>
                                        ) 
                                        : 
                                        (
                                            <a>Ошибка системы</a>
                                        )
                                    ) 
                                    : 
                                    (
                                        <a>Чтобы назначить арбитражного управляющего необходимо закрепить работника</a>
                                    )}
                                </div>
                            </>}
                            <h2>Комментарий:</h2>
                            <a>{formatComment(cases.comments)}</a>
                            <h2>Файл:</h2>
                            <a>
                                {warningDownloadFile ? (
                                    <a className={styles.statusPanel}><img src='/img/icons/warning-icon.svg' alt='Предупреждение' />{warningDownloadFile}</a>
                                ) 
                                : 
                                cases.file ? (
                                    <button type='button' className='button black' onClick={() => downloadFile(id)}>Скачать файл</button>
                                )
                                :
                                (
                                    formatFile(cases.file)
                                )
                                }
                            </a>
                            <h2>Дата и время создания карточки:</h2>
                            <a>{formatDateTime(cases.time_creation)}</a>
                            <h2>Начальная дата:</h2>
                            <a>{formatDate(cases.date_start)}</a>
                            <h2>Конечная дата:</h2>
                            <a>{formatDate(cases.date_end)}</a>
                            <h2>Статус:</h2>
                            <a className={highlightedPhase === cases.id ? styles.highlight : ''} style={{marginBottom: '10px', display: 'flex', alignItems: 'center'}}>{cases.status=="В работе" ? (
                                <>
                                    <svg style={{width: '30px'}} viewBox="0 0 24 24" id="angle-right-b"><path fill="#6563FF" d="M15.54,11.29,9.88,5.64a1,1,0,0,0-1.42,0,1,1,0,0,0,0,1.41l4.95,5L8.46,17a1,1,0,0,0,0,1.41,1,1,0,0,0,.71.3,1,1,0,0,0,.71-.3l5.66-5.65A1,1,0,0,0,15.54,11.29Z"></path></svg>
                                    {cases.status}
                                </>
                                ) : (
                                <>
                                    <svg style={{width: '30px'}} viewBox="0 0 24 24" id="check"><path fill="#6563FF" d="M18.71,7.21a1,1,0,0,0-1.42,0L9.84,14.67,6.71,11.53A1,1,0,1,0,5.29,13l3.84,3.84a1,1,0,0,0,1.42,0l8.16-8.16A1,1,0,0,0,18.71,7.21Z"></path></svg>
                                    {cases.status}
                                </>
                                )}</a>
                            <h2>Действия:</h2>
                            {cases.status=="В работе" ? (
                                <>
                                    <button type='button' className='button maxWidth' onClick={() => goPhase(cases.id)}>{namePhase !== 'Назначение арбитражного управляющего' ? ('Продвинуть дело далее') : (cases.nameType == 'Назначения' ? ('Продвинуть заявку далее') : (cases.nameType == 'Жалобы' ? ('Продвинуть жалобу далее') : (cases.nameType == 'Общие' ? ('Продвинуть письмо далее') : ('Ошибка системы'))))}</button>
                                </>
                                ) : (
                                <>
                                </>
                                )
                            }
                            <>
                                <button type='button' className='button maxWidth' onClick={handleShareClick}>{shareButtonText}</button>
                            </>
                            {access && 
                                <button 
                                    type='button' 
                                    className='button maxWidth black' 
                                    onClick={() => handleDeleteClick(cases.id)}
                                >
                                    {confirmDelete ? "Вы уверены, что хотите удалить дело?" : "Удалить"}
                                </button>
                            }
                        </>
                    ))
                )}
            </div>
            </form>
        </div>
    </>
    )
}

export default CardOfCase;